import { animate } from "framer-motion";
import { useEffect, useRef } from "react";

import { GAME_RESULTS_ANIMATION_DURATION } from "../../../constants";

import styles from "./NumberCounter.module.scss";

export function NumberCounter({ to }: { to: number }) {
  const ref = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const controls = animate(0, to, {
      duration: GAME_RESULTS_ANIMATION_DURATION,
      onUpdate(value) {
        if (ref.current) {
          ref.current.textContent = `${value.toFixed(0)}%`;
        }
      },
    });

    return () => controls.stop();
  }, [to]);

  return <span className={styles.counter} ref={ref} />;
}
